import { FC, useRef } from "react";
import { Menu, Dropdown } from "antd";
import {
  Wrapper,
  InsightsWrapper,
  DropdownWrapper,
  DetailsWrapper,
  Header,
  TitleWrapper,
  Item,
  ItemCount
} from "./elements";
import { MoreOutlined } from "@ant-design/icons";
import { CSVLink } from "react-csv";
import { toJpeg, toCanvas } from "html-to-image";
import { jsPDF } from "jspdf";

type Props = {
  item: { accepted: number; declined: number; waiting: number };
  onClickMenu?: (e: any) => void;
  dateRange?: any;
};

const JobOfferInsights: FC<Props> = ({ item, onClickMenu, dateRange }) => {
  const csvRef = useRef<any>();
  const jpgRef = useRef<any>();

  const filteredDate = dateRange
    ? `${dateRange[0].format("YYYY-MM-DD")} - ${dateRange[1].format(
        "YYYY-MM-DD"
      )}`
    : "";

  const handleClickMenu = (e: any) => {
    if (onClickMenu) {
      onClickMenu(e);
    } else {
      switch (e.key) {
        case "CSV":
          csvRef.current?.link.click();
          break;
        case "JPG":
          toJpeg(jpgRef.current, { cacheBust: true })
            .then(url => {
              const link = document.createElement("a");
              link.download = `JobOfferInsights.jpg`;
              link.href = url;
              link.click();
            })
            .catch(err => {
              console.log(err);
            });
          break;
        default:
          toCanvas(jpgRef.current).then(canvas => {
            const image = canvas.toDataURL("image/jpeg", 1.0);
            const doc = new jsPDF("p", "px", "a4");
            doc.addImage(image, "JPEG", 10, 10, 0, 0);
            doc.save(`jobofferinsights.pdf`);
          });
          break;
      }
    }
  };

  const dropdownMenu = (
    <Menu onClick={handleClickMenu}>
      <Menu.Item key="JPG">Download JPG</Menu.Item>
      <Menu.Item key="PDF">Download PDF</Menu.Item>
      <Menu.Item key="CSV">Download CSV</Menu.Item>
    </Menu>
  );

  return (
    <Wrapper ref={jpgRef}>
      <InsightsWrapper>
        <Header>
          <TitleWrapper>Job offer</TitleWrapper>
          <DropdownWrapper>
            <Dropdown
              trigger={["click"]}
              overlay={dropdownMenu}
              placement="bottomLeft"
            >
              <MoreOutlined
                rotate={90}
                style={{ fontSize: "26px", color: "#000000" }}
              />
            </Dropdown>
          </DropdownWrapper>
        </Header>
        <DetailsWrapper>
          <Item type="accepted" data-title="Accepted">
            <ItemCount>{item.accepted}</ItemCount>
          </Item>
          <Item type="declined" data-title="Declined">
            <ItemCount>{item.declined}</ItemCount>
          </Item>
          <Item type="waiting" data-title="Waiting for response">
            <ItemCount>{item.waiting}</ItemCount>
          </Item>
        </DetailsWrapper>
      </InsightsWrapper>

      <CSVLink
        style={{ visibility: "hidden" }}
        data={[
          { firstRow: "Date Range: ", secondRow: filteredDate, thirdRow: "" },
          {},
          {
            firstRow: "Accepted",
            secondRow: "Declined",
            thirdRow: "Waiting for response"
          },
          {
            firstRow: item.accepted,
            secondRow: item.declined,
            thirdRow: item.waiting
          }
        ]}
        headers={[
          { key: "firstRow", label: "" },
          { key: "secondRow", label: "" },
          { key: "thirdRow", label: "" }
        ]}
        filename="Job Offer Insights.csv"
        ref={csvRef}
      />
    </Wrapper>
  );
};

export default JobOfferInsights;
